import React from "react";
import "./StepFour.css";
import {
  Button,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  styled,
  TableFooter,
} from "@mui/material";
import { stepFourData } from "../stepsData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import tongueOut from "../../../../../Assets/Images/tongue-out.webp";
import Calculator from "./Calculator/Calculator";

const StepFour = () => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  // Styling Table Cell
  const tableHeadingsStyle = {
    xs: "14px",
    lg: "16px",
  };
  const tableContentStyle = {
    md: "14px",
    lg: "16px",
  };

  return (
    <>
      <div className="step_four mt-2">
        <Typography
          sx={{ fontSize: "23.8532px", fontFamily: "'Archivo', sans-serif" }}
          className="fw-bold"
        >
          {stepFourData[0].stepFourHeading}
        </Typography>
        <div>
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              fontFamily: "'Archivo', sans-serif",
            }}
            className="archivo mt-2"
          >
            {stepFourData[0].paraOne}
          </Typography>

          <ul
            style={{ listStyle: "disc", fontSize: 16, color: "#1f1f1f" }}
            className=" archivo"
          >
            {stepFourData[0].debtCalculatorList &&
              stepFourData[0].debtCalculatorList.map((item, index) => (
                <li key={index}>
                  <strong>{item.head}</strong> {item.info}
                </li>
              ))}
          </ul>

          <div className="mt-4">
            <Typography
              sx={{
                fontSize: 16,
                lineHeight: "24px",
                fontWeight: 600,
                fontFamily: "'Archivo', sans-serif",
              }}
              className="archivo my-3"
            >
              Example:
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow
                    sx={{
                      // backgroundColor: "#e6c1fd",
                      // backgroundColor: "#E2E3E5",
                      backgroundColor: "#e7e4f9",
                      alignContent: "start",
                    }}
                  >
                    {stepFourData[0].debtTable.headings &&
                      stepFourData[0].debtTable.headings.map((item, index) => (
                        <TableCell
                          key={index}
                          sx={{
                            fontSize: tableHeadingsStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #c7c7c7",
                            verticalAlign: "top",
                          }}
                          className="archivo"
                        >
                          {item.head}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stepFourData[0].debtTable.row &&
                    stepFourData[0].debtTable.row.map((item, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            verticalAlign: "top",
                          }}
                        >
                          {item.loanType}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            verticalAlign: "top",
                          }}
                        >
                          {item.amount}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            verticalAlign: "top",
                          }}
                        >
                          {item.interest}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            verticalAlign: "top",
                          }}
                        >
                          {item.tenure}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            verticalAlign: "top",
                          }}
                        >
                          {item.emi}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            verticalAlign: "top",
                          }}
                        >
                          {item.repayment}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
                <TableFooter>
                  <StyledTableRow>
                    <StyledTableCell
                      colSpan={1}
                      sx={{
                        fontSize: tableContentStyle,
                        fontWeight: 600,
                        fontFamily: "'Archivo', sans-serif",
                        color: "#1F1F1F",
                        borderRight: "1px solid #E0E0E0",
                        verticalAlign: "top",
                      }}
                    >
                      Total
                    </StyledTableCell>
                    <StyledTableCell
                      colSpan={3}
                      sx={{
                        fontSize: tableContentStyle,
                        fontWeight: 600,
                        fontFamily: "'Archivo', sans-serif",
                        color: "#1F1F1F",
                        borderRight: "1px solid #E0E0E0",
                        verticalAlign: "top",
                      }}
                    >
                      ₹4,00,000
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        fontSize: tableContentStyle,
                        fontWeight: 600,
                        fontFamily: "'Archivo', sans-serif",
                        color: "#1F1F1F",
                        borderRight: "1px solid #E0E0E0",
                        verticalAlign: "top",
                      }}
                    >
                      ₹19,149
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        fontSize: tableContentStyle,
                        fontWeight: 600,
                        fontFamily: "'Archivo', sans-serif",
                        color: "#1F1F1F",
                        borderRight: "1px solid #E0E0E0",
                        verticalAlign: "top",
                      }}
                    >
                      ₹4,88,520
                    </StyledTableCell>
                  </StyledTableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
          <div className="mt-4 pb-2">
            <Typography
              sx={{
                fontSize: 16,
                lineHeight: "24px",
                fontWeight: 600,
                fontFamily: "'Archivo', sans-serif",
                verticalAlign: "top",
              }}
              className="archivo my-3"
            >
              Consolidated Loan:
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow
                    sx={{
                      // backgroundColor: "#e6c1fd",
                      // backgroundColor: "#E2E3E5",
                      backgroundColor: "#e7e4f9",
                    }}
                  >
                    {stepFourData[0].consolidationTable.headings &&
                      stepFourData[0].consolidationTable.headings.map(
                        (item, index) => (
                          <TableCell
                            key={index}
                            sx={{
                              fontSize: tableHeadingsStyle,
                              fontFamily: "'Archivo', sans-serif",
                              color: "#1F1F1F",
                              borderRight: "1px solid #c7c7c7",
                              verticalAlign: "top",
                            }}
                            className="archivo"
                          >
                            {item.head}
                          </TableCell>
                        )
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stepFourData[0].consolidationTable.row &&
                    stepFourData[0].consolidationTable.row.map(
                      (item, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell
                            sx={{
                              fontSize: tableContentStyle,
                              fontFamily: "'Archivo', sans-serif",
                              color: "#1F1F1F",
                              borderRight: "1px solid #E0E0E0",
                              verticalAlign: "top",
                            }}
                          >
                            {item.amount}
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{
                              fontSize: tableContentStyle,
                              fontFamily: "'Archivo', sans-serif",
                              color: "#1F1F1F",
                              borderRight: "1px solid #E0E0E0",
                              verticalAlign: "top",
                            }}
                          >
                            {item.interest}
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{
                              fontSize: tableContentStyle,
                              fontFamily: "'Archivo', sans-serif",
                              color: "#1F1F1F",
                              borderRight: "1px solid #E0E0E0",
                              verticalAlign: "top",
                            }}
                          >
                            {item.tenure}
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{
                              fontSize: tableContentStyle,
                              fontFamily: "'Archivo', sans-serif",
                              color: "#1F1F1F",
                              borderRight: "1px solid #E0E0E0",
                              verticalAlign: "top",
                            }}
                          >
                            {item.emi}
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{
                              fontSize: tableContentStyle,
                              fontFamily: "'Archivo', sans-serif",
                              color: "#1F1F1F",
                              borderRight: "1px solid #E0E0E0",
                              verticalAlign: "top",
                            }}
                          >
                            {item.repayment}
                          </StyledTableCell>
                        </StyledTableRow>
                      )
                    )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <section className="loan_calculator rounded mt-4 ">
            <Calculator />
          </section>
        </div>
      </div>
      <div className="tips mt-4 ">
        <div id="border_line"></div>
        <div id="tip__container" className="px-2 px-sm-4 py-4">
          <div className="px-3 py-2">
            <div className="d-flex flex-row gap-2 align-items-center">
              <img src={tongueOut} alt="" style={{ width: 30, height: 30 }} />
              <Typography
                sx={{
                  fontSize: 16,
                  lineHeight: "24px",
                  letterSpacing: "0.08px",
                  color: "#59266D",
                  // color: "yellow",
                  fontFamily: "'Archivo', sans-serif",
                }}
              >
                MinEmi Tip:
              </Typography>
            </div>
            <div className="mt-2">
              <Typography
                sx={{
                  fontSize: 16,
                  lineHeight: "24px",
                  letterSpacing: "0.08px",
                  color: "#1F1F1F",
                  // color: "#f8f8f8",

                  fontFamily: "'Archivo', sans-serif",
                }}
              >
                {stepFourData[0].tip}
              </Typography>
            </div>
          </div>
        </div>
      </div>
      <Button
        sx={{
          textTransform: "none",
          margin: "0px",
          fontSize: 16,
          fontFamily: "'Archivo', sans-serif",
        }}
        onClick={() => {
          window.scroll(0, 0);
        }}
        className="d-flex algin-items-center archivo mt-2"
      >
        <FontAwesomeIcon icon={faArrowUp} /> &nbsp; Back To Top
      </Button>
    </>
  );
};

export default StepFour;
